import dayjs from "dayjs";

export default {
    regexChk(payload) {
        let regex = payload;
        const spChars = [
            // "`",
            // "-",
            // "=",
            // ";",
            // "'",
            // "/",
            // "~",
            // "!",
            // "@",
            // "#",
            // "$",
            // "%",
            // "^",
            // "&",
            // "|",
            // ":",
            // "<",
            // ">",
            "\\",
            "*",
            "+",
            "{",
            "}",
            "?",
            ".",
            ")",
            "(",
            "]",
            "[",
            "^",
        ];
        // eslint-disable-next-line no-plusplus
        for (let i = 0; i < spChars.length; i++) {
            regex = regex.replaceAll(spChars[i], `\\${spChars[i]}`);
        }
        return regex;
    },

    commaMaker(str) {
        return String(str).replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    },
    chkOnlyNumber(inData) {
        const onlyNumberPattern = /^[0-9]+$/;
        if (onlyNumberPattern.test(inData) === false) {
            return false;
        }
        return true;
    },
    chkOnlyEng(inData) {
        const onlyEnglishPattern = /^[^0-9ㄱ-ㅎㅏ-ㅣ가-힣]+$/;

        if (onlyEnglishPattern.test(inData) === false) {
            return false;
        }
        return true;
    },
    chkOnlyWord(inData) {
        const onlyWordPattern =
            // eslint-disable-next-line
            /^[ㄱ-ㅎㅏ-ㅣ가-힣a-zA-Z0-9\{\}\[\]\/?.,;:|\)*~`!^\-_+<>@\#$%&\\\=\(\'\"\n\t\s]*$/;
        if (onlyWordPattern.test(inData) === false) {
            // alert("사용할수 없는 문자입니다. 확인 후 다시 시도해주세요.");
            return false;
        }
        return true;
    },

    nullChk(inData) {
        if (inData === null || inData === "" || inData === undefined || inData?.length === 0) {
            return false;
        }
        return true;
    },

    nullChk2(inData) {
        if (inData === null || inData === "" || inData === undefined || inData === "-") {
            return false;
        }
        return true;
    },

    nullReplace(origin, target) {
        if (origin === null || origin === "" || origin === undefined) {
            return target;
        }
        return origin;
    },

    strValidChk(inData, pattern) {
        if (!this.nullChk(inData)) return false;
        if (!this.chkOnlyWord(inData)) return false;

        const res = pattern.test(inData);

        return res;
    },

    ipValidChk(inData) {
        if (!this.nullChk(inData)) return false;
        if (!this.chkOnlyWord(inData)) return false;

        const ipPattern =
            /^(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$/;

        const res = ipPattern.test(inData);

        return res;
    },

    emailValidChk(inData) {
        if (!this.nullChk(inData)) return false;
        if (!this.chkOnlyWord(inData)) return false;

        const emailPattern =
            /^([-_.]?[0-9a-zA-Z])+@[0-9a-zA-Z]([-_.]?[0-9a-zA-Z])*.[a-zA-Z]{2,3}$/i;

        const res = emailPattern.test(inData);

        return res;
    },

    pwdValidChk(inData) {
        if (!this.nullChk(inData)) return false;
        if (!this.chkOnlyWord(inData)) return false;

        const pwdPattern = /^(?=.*[a-zA-Z0-9])(?=.*[!@#$%^*+=-])(?=.*[0-9]).{8,}$/;

        const res = pwdPattern.test(inData);

        return res;
    },

    telValidChk(inData) {
        if (!this.nullChk(inData)) return false;
        if (!this.chkOnlyWord(inData)) return false;

        const telPattern = /^(01[016789]{1}|02|0[3-9]{1}[0-9]{1})-?[0-9]{3,4}-?[0-9]{4}$/g;

        const res = telPattern.test(inData);

        return res;
    },
    /**
     * 000-0000-0000 번호 정규식
     * @param {*} inData
     * @returns
     */
    telValidWithHyphen(inData) {
        if (!this.nullChk(inData)) return false;
        if (!this.chkOnlyWord(inData)) return false;

        const telPattern = /^(01[0-9])-\d{3,4}-\d{4}$/;

        const res = telPattern.test(inData);

        return res;
    },

    /**
     * 기간 확인
     * - 시작, 종료 기간 확인
     * @param {*} s_date
     * @param {*} e_date
     * @returns
     */
    dateRangeCheck(s_date, e_date) {
        if (!this.nullChk(s_date) || !this.nullChk(e_date)) return false;
        if (!this.chkOnlyWord(s_date) || !this.chkOnlyWord(e_date)) return false;

        const start_date = dayjs(s_date);
        const end_date = dayjs(e_date);

        const res = start_date.isAfter(end_date) ? false : true;

        return res;
    },

    /**
     * trim object
     * @param {*} object
     * @returns
     */
    trimObject(object) {
        const keys = Object.keys(object);

        for (let i = 0; i < keys.length; i++) {
            const key = keys[i];
            const value = object[key];

            if (typeof value === "string") {
                object[key] = value.trim();
            }
        }

        return object;
    },
    /**
     * 비밀번호 valid check
     * 영문자+숫자 8~20자리 [특수 문자 포함 가능]
     * @param {*} password
     * @returns
     */
    passwordCheck(password) {
        // 특수문자 검사를 포함하는 수정된 정규식
        const regex =
            /^(?=.*[a-zA-Z])(?=.*[0-9])(?=.*[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]).{8,20}$/;
        return regex.test(password);
    },

    /*
		이름 valid check
		특수문자 입력 제한
	*/
    nameValidCheck(inData, min, max) {
        if (!this.nullChk(inData)) return false;
        if (!this.chkOnlyWord(inData)) return false;

        const namePattern = new RegExp(`/^[a-zA-Z가-힣]{${min},${max}}$/`);

        const res = namePattern.test(inData);

        return res;
    },

    normalizeObject(val, exclude = new Set()) {
        if (val === null || val === undefined || val === "") {
            return "";
        }

        if (typeof val === "object" && !Array.isArray(val)) {
            const normalized = {};
            Object.keys(val)
                .filter((key) => !exclude.has(key))
                .sort()
                .forEach((key) => {
                    normalized[key] = this.normalizeObject(val[key], exclude);
                });
            return normalized;
        }

        // 배열도 재귀 지원 (배열 순서는 유지)
        if (Array.isArray(val)) {
            return val.map((item) => this.normalizeObject(item, exclude));
        }

        return val;
    },

    isChanged(origin, target, exclude = ["id"]) {
        const excludeSet = new Set(exclude);

        const a = this.normalizeObject(origin, excludeSet);
        const b = this.normalizeObject(target, excludeSet);

        return JSON.stringify(a) !== JSON.stringify(b);
    },
};
